/**
 * @module logger
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

/**
 * Constant required for logger
 * @access public - global
 */
export const LOGLEVEL = {
  ALL: 'ALL',
  VERBOSE: 'VERBOSE',
  DEFAULT: 'DEFAULT',
  OFF: 'OFF',
};
export const MAXSTRMATCH: number = 200;
